import Vue from 'vue'
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { PLANNER_API_URL } from '@/config'

const mixins = Vue.mixin({
  computed: {
    ...mapGetters(['progress', 'settings', '_', 'filter', 'favorites', 'key']),
  },
  methods: {
    ...mapMutations(['setProgress', 'setBack', 'setUser', 'setModal']),
    ...mapActions(['getSessions', 'getUser']),
    formatDay(day) {
      return this._.date_format_program
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name])
        .replace('&y', day.year);
    },
    async toggleSession(sval) {
      if (!this.key) {
        this.setModal(true);
        return;
      }

      await Vue.axios.get(PLANNER_API_URL + '/program/favorites/sessions/' + sval.id, {
        headers: { 'x-api-key': this.key }
      });
      this.setProgress(false);
      if (this.favorites.sessions.find(fav => fav === sval.id)) {
        this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
      } else {
        this.favorites.sessions.push(sval.id);
        sval.presentations.map(presentation => {
          this.favorites.presentations = this.favorites.presentations.filter(fav => fav !== presentation.id);
        });
      }
    },
    async togglePresentation(sval, ckey) {
      if (!this.key) {
        this.setModal(true);
        return;
      }

      const id = sval.presentations[ckey].id;
      await Vue.axios.get(PLANNER_API_URL + '/program/favorites/sessions/' + sval.id + '/presentations/' + id, {
         headers: { 'x-api-key': this.key }
      });
      this.setProgress(false);
      
      if (this.favorites.sessions.find(fav => fav === sval.id)) {
        this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
        const presentations = sval.presentations.reduce((carry, presentation) => { 
          if (presentation.id !== id && !this.favorites.presentations.includes(id)) carry.push(presentation.id);
          return carry; 
        }, []);
        this.favorites.presentations = this.favorites.presentations.concat(presentations);
      } else if (this.favorites.presentations.find(fav => fav === id)) {
        this.favorites.presentations = this.favorites.presentations.filter(fav => fav !== id);
      } else {
        if (sval.presentations.every(presentation => this.favorites.presentations.concat([id]).includes(presentation.id))) {
          sval.presentations.map(presentation => {
            this.favorites.presentations = this.favorites.presentations.filter(fav => fav !== presentation.id);
          });
          if (!this.favorites.sessions.find(fav => fav === sval.id)) {
            this.favorites.sessions.push(sval.id);
          }
        } else {
          if (this.favorites.sessions.find(fav => fav === sval.id)) {
            this.favorites.sessions = this.favorites.sessions.filter(fav => fav !== sval.id);
          }
          this.favorites.presentations.push(id);
        }
      }
    },
    async syncFavorites() {
      const options = {
        params: {
          sessions: this.favorites.sessions,
          presentations: this.favorites.presentations,
        },
      };
      if (this.key) options.headers = { 'x-api-key': this.key };
      const favorites = await this.axios.get(PLANNER_API_URL + '/program/favorites', options);
      this.favorites.sessions = favorites.data.sessions.map(session => session.id);
      this.favorites.presentations = favorites.data.presentations.map(presentation => presentation.id);
      this.setProgress(false);
    },
  }
})

export default mixins
